import {get} from 'sdk';
import {BASE_URL} from 'appConstants';

export const fetchCountries = () => {
  const url = `${BASE_URL}/v1/locations/countries/`;

  return get(url);
};
